<template>
    <div class="placeOrder">
        <div class="orderBox" v-for="(item, index) in product" :key="index">
            <div class="back" @click="backBtn">&lt;&nbsp;{{ $t('meg.back') }}</div>
            <div class="infor">{{ $t('meg.Ordering') }}</div>
            <div class="formBox">
                <el-form :inline="true" :model="orderForm" class="demo-form-inline" :rules="orderFormRules">
                    <el-form-item :label="$t('meg.CustomerName')" required prop="companyName">
                        <el-input v-model="orderForm.companyName" disabled />
                    </el-form-item>
                    <el-form-item :label="$t('meg.contacts')" required style="margin-left: .875rem" prop="contacts">
                        <el-input v-model="orderForm.contacts" placeholder="请输入联系人" clearable />
                    </el-form-item>
                    <el-form-item :label="$t('meg.contactsInformation')" required style="margin-left: .875rem"
                        prop="phonenumber">
                        <el-input v-model="orderForm.phonenumber" placeholder="请输入联系方式" clearable />
                    </el-form-item>
                </el-form>
                <el-form :model="orderForm" class="demo-form-inline" :rules="orderFormRules">
                    <el-form-item :label="$t('meg.Inspection')" required>
                        <el-checkbox-group v-model="orderForm.examineWay">
                            <el-checkbox label="1" name="type">前期</el-checkbox>
                            <el-checkbox label="2" name="type">中期</el-checkbox>
                            <el-checkbox label="3" name="type">尾期</el-checkbox>
                        </el-checkbox-group>
                        <el-radio-group v-model="orderForm.thirdParty">
                            <el-radio label="1" name="type">第三方现场检</el-radio>
                            <el-radio label="2" name="type">自检</el-radio>
                            <el-radio label="3" name="type">检品公司</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="orderForm.inspectionMethod" style="margin-left: 1rem;">
                            <el-radio label="1" name="type">抽检</el-radio>
                            <el-radio label="2" name="type">全检</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.CustomerType')" required>
                        <el-checkbox-group v-model="orderForm.type" prop="type">
                            <el-checkbox label="1" name="type">品牌商</el-checkbox>
                            <el-checkbox label="2" name="type">贸易公司</el-checkbox>
                            <el-checkbox label="3" name="type">工厂</el-checkbox>
                            <el-checkbox label="4" name="type">设计师品牌</el-checkbox>
                            <!-- <el-checkbox label="5" name="type">公司</el-checkbox> -->
                            <el-checkbox label="6" name="type">电商</el-checkbox>
                            <el-checkbox label="7" name="type">其他</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.ordertt')" required prop="ordertype">
                        <el-checkbox-group v-model="orderForm.ordertype">
                            <el-checkbox label="1" name="type">内销</el-checkbox>
                            <el-checkbox label="2" name="type">外贸</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.productiontype')" required prop="productiontype">
                        <el-checkbox-group v-model="orderForm.productiontype">
                            <el-checkbox label="1" name="type">FOB(包工包料)</el-checkbox>
                            <el-checkbox label="2" name="type">ODM(设计+代工)</el-checkbox>
                            <el-checkbox label="3" name="type">OEM(代工)</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.producttype')" required prop="producttype">
                        <el-checkbox-group v-model="orderForm.producttype">
                            <el-checkbox label="1" name="type">针织</el-checkbox>
                            <el-checkbox label="2" name="type">梭织</el-checkbox>
                            <el-checkbox label="3" name="type">针织+梭织</el-checkbox>
                            <el-checkbox label="4" name="type">牛仔</el-checkbox>
                            <el-checkbox label="5" name="type">毛衫</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.processtype')" required prop="processtype">
                        <el-checkbox-group v-model="orderForm.processtype">
                            <el-checkbox label="1" name="type">裁剪</el-checkbox>
                            <el-checkbox label="2" name="type">缝制</el-checkbox>
                            <el-checkbox label="3" name="type">包装</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item :label="$t('meg.pictures')" required>
                        <div style="display: flex;flex-direction: column;margin-left: .1875rem">
                            <el-upload v-model="orderForm.pictures" class="upload-demo" :action="uploadUrl"
                                :headers="{ Authorization: acc_token }" ref="imageUpload"
                                :on-success="handleImageUploadSuccess" :before-upload="beforeImageUpload"
                                :on-exceed="handleImageExceed" :on-error="handleImageError" accept="image/jpeg,image/png"
                                :max-size="5 * 1024 * 1024">
                                <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                            </el-upload>
                            <p
                                style="font-size: .175rem;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;">
                                {{ $t('meg.uploaded') }}</p>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('meg.preparation')" required>
                        <div style="display: flex;flex-direction: column;">
                            <el-upload v-model="orderForm.preparation" class="upload-demo" :action="uploadUrl"
                                :headers="{ Authorization: acc_token }" ref="upload" :limit="1"
                                :on-success="orderContractSuccess" :before-upload="beforePDFUpload"
                                :on-exceed="handleExceed" :on-error="handleError" accept=".pdf">
                                <el-button class="uploadBtn">{{ $t('meg.upload') }}</el-button>
                            </el-upload>
                            <p
                                style="font-size: .175rem;font-family: PingFang SC, PingFang SC;font-weight: 500;color: #777777;">
                                {{ $t('meg.PDF') }}</p>
                        </div>
                    </el-form-item>
                    <el-form-item :label="$t('meg.productName')" required prop="orderNum">
                        <el-input v-model="orderForm.productName" clearable />
                    </el-form-item>
                </el-form>
                <div style="margin-right: .625rem;width: 80%;">
                    <p
                        style="margin-bottom: .1875rem; text-align: right; font-size: .2rem;font-family: PingFang SC, PingFang SC;font-weight: bold;color: #002FA7;">
                        {{ $t('meg.total') }}：{{ totalOrderQuantity }}</p>
                    <el-table class="orderTable" :data="item.tableList" style="max-width: 100%;overflow-x:auto"
                        :header-cell-style="{ 'background': '#F7F9FD !important', 'color': '#333', 'height': '.7rem !important' }">
                        <el-table-column :label="$t('meg.color')">
                            <template #default="scope">
                                <el-input size="small" v-model="scope.row.skuColor" />
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('meg.quantity')" prop="quantity">
                            <template #default="scope">
                                {{ calculateTotal(scope.row, item) }}
                            </template>
                        </el-table-column>
                        <el-table-column v-for="(count, index) in item.inputCounts" :key="index">
                            <template #header>
                                <el-input size="small" v-model="item.inputCounts[index]" />
                            </template>
                            <template #default="scope">
                                <el-input size="small" v-model="scope.row[item.inputCounts[index]]" />
                            </template>
                        </el-table-column>
                        <el-table-column>
                            <template #header>
                                <el-button class="chimaBtn" @click="addInput(index)" style="padding: 0;">+新增尺码</el-button>
                                <el-button class="chimaBtn" @click="deleteSize(index)" style="padding: 0;">-删除尺码</el-button>
                            </template>
                            <template #default="scope">
                                <el-button link type="primary" size="small"
                                    @click.prevent="deleteRow(scope.$index, item.tableList)">
                                    {{ $t('meg.deletecolor') }}
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <p class="colorStyle" @click="addTableRow(item.tableList)">
                    +{{ $t('meg.addcolor') }}</p>

                <!-- 交付信息 -->
                <div class="infor" style="margin-left: 0;">{{ $t('meg.DeliveryInfo') }}</div>
                <div style="margin-top: .3rem;">
                    <el-form :inline="true" :model="orderForm" class="demo-form-inline" :rules="orderFormRules">
                        <el-form-item :label="$t('meg.arrivaltime')" required prop="arrivaltime">
                            <el-date-picker v-model="orderForm.arrivaltime" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.deliveryType')" required style="margin-left: .875rem"
                            prop="deliveryType">
                            <el-radio-group v-model="orderForm.deliveryType">
                                <el-radio label="1" name="type">分批出货</el-radio>
                                <el-radio label="2" name="type">整批出货</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('meg.shippingtime')" required prop="shippingtime"
                            style="margin-left: .875rem">
                            <el-date-picker v-model="orderForm.shippingtime" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择" />
                        </el-form-item>
                    </el-form>
                    <el-form :model="orderForm" :rules="orderFormRules" class="demo-form-inline">
                        <el-form-item :label="$t('meg.destination')" required prop="destination">
                            <el-input v-model="orderForm.destination" placeholder="请输入"
                                style="width: 8.1875rem;margin-left: .1625rem;" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.Payment')" required>
                        </el-form-item>
                    </el-form>
                    <el-form :inline="true" :model="orderForm" :rules="orderFormRules" class="demo-form-inline">
                        <el-form-item :label="$t('meg.advance')" required prop="advance">
                            <el-input v-model="orderForm.advance" placeholder="请输入">
                                <template #append>%</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('meg.shipment')" required prop="payment" style="margin-left: .875rem">
                            <el-input v-model="orderForm.payment" placeholder="请输入">
                                <template #append>%</template>
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('meg.balance')" required prop="balance" style="margin-left: .875rem">
                            <el-input v-model="orderForm.balance" placeholder="请输入">
                                <template #append>%</template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <el-form :model="orderForm" class="demo-form-inline" :rules="orderFormRules">
                        <el-form-item :label="$t('meg.period')" required prop="period">
                            <el-date-picker v-model="orderForm.period" value-format="YYYY-MM-DD" type="date"
                                placeholder="请选择" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.points')" required>
                        </el-form-item>
                    </el-form>
                    <el-form :inline="true" :model="orderForm" :rules="orderFormRules" class="demo-form-inline">
                        <el-form-item :label="$t('meg.general')">
                            <el-input v-model="orderForm.general" />
                        </el-form-item>
                        <el-form-item :label="$t('meg.special')">
                            <el-input v-model="orderForm.special" />
                        </el-form-item>
                    </el-form>
                    <el-form :model="orderForm" class="demo-form-inline" :rules="orderFormRules">
                        <el-form-item :label="$t('meg.settlement')" required prop="settlement">
                            <el-checkbox-group v-model="orderForm.settlement">
                                <el-checkbox label="1" name="type">电汇</el-checkbox>
                                <el-checkbox label="2" name="type">信用证</el-checkbox>
                                <el-checkbox label="3" name="type">承兑</el-checkbox>
                                <el-checkbox label="4" name="type" style="margin-right: .1875rem;">其他</el-checkbox>
                            </el-checkbox-group>
                            <el-input  v-model="orderForm.other " />
                        </el-form-item>
                        <el-form-item :label="$t('meg.shipping')" required prop="shipping">
                            <el-checkbox-group v-model="orderForm.shipping">
                                <el-checkbox label="1" name="type">自出</el-checkbox>
                                <el-checkbox label="2" name="type">汇智衣代出</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item :label="$t('meg.money')" required>
                            <el-radio-group v-model="orderForm.currencyType">
                                <el-radio v-for="(item, index) in money" :label=item.dictValue
                                    :key=item.dictValue>{{ item.remark }}

                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('meg.price')" required prop="price">
                            <el-input v-model="orderForm.price" />
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div style="margin: .8625rem; auto">
                <el-button class="submit" @click="orderBtn">{{ $t('meg.submit') }}</el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { customerOrder, getOrderUser, productDetails } from "@/api/placeorder.js"
import { getDicts } from "@/api/order.js"
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from 'vue-router';
onMounted(() => {
    getUser()
    productId.value = route.query.productId
    productDetails(productId.value).then(res => {
        orderForm.productName = res.data.data.productName
    })
    getDicts("currency_type").then(res => {
        money.value = res.data.data
    })
})
const router = useRouter()
const route = useRoute()
const productId = ref("")
const money = ref([])
const acc_token = localStorage.getItem('access_token')
const uploadUrl = ref('/dev-api' + '/file/upload')

const backBtn = () => {
    router.go(-1)
}

//校验规则
const orderFormRules = {
    contacts: [
        { required: true, message: '请输入联系人', trigger: 'blur' },
    ],
    phonenumber: [
        { required: true, message: '请输入联系方式', trigger: 'blur' },
    ],
    type: [
        { required: true, message: '请选择客户类型', trigger: 'change' },
    ],
    ordertype: [
        { required: true, message: '请选择订单类型', trigger: 'change' },
    ],
    productiontype: [
        { required: true, message: '请选择生产类型', trigger: 'change' },
    ],
    producttype: [
        { required: true, message: '请选择产品类型', trigger: 'change' },
    ],
    processtype: [
        { required: true, message: '请选择加工类型', trigger: 'change' },
    ],
    // ... add rules for other form fields ...
    // orderNum: [
    //     { required: true, message: '请输入订单数量', trigger: 'blur' },
    // ],
    destination: [
        { required: true, message: '请输入交货目的地', trigger: 'blur' },
        // Add additional validation rules as needed
    ],
    arrivaltime: [
        { required: true, message: '请选择物料到厂时间', trigger: 'change' },
    ],
    deliveryType: [
        { required: true, message: '请选择交货类型', trigger: 'change' },
    ],
    shippingtime: [
        { required: true, message: '请选择出货时间', trigger: 'change' },
    ],
    advance: [
        { required: true, message: '请输入预付款', trigger: 'blur' },
    ],
    payment: [
        { required: true, message: '请输入出货款', trigger: 'blur' },
    ],
    period: [
        { required: true, message: '请选择账期', trigger: 'change' },
    ],
    balance: [
        { required: true, message: '请输入尾款', trigger: 'blur' },
    ],
    // general: [
    //     { required: true, message: '请输入普票税点', trigger: 'blur' },
    // ],
    // special: [
    //     { required: true, message: '请输入专票税点', trigger: 'blur' },
    // ],
    settlement: [
        { required: true, message: '请选择结算方式', trigger: 'change' },
    ],
    shipping: [
        { required: true, message: '请选择出货方式', trigger: 'change' },
    ],
    price: [
        { required: true, message: '请输入意向目标价', trigger: 'blur' },
    ],
};

const orderForm = reactive({
    companyName: '',
    contacts: '',
    phonenumber: '',
    type: [],
    ordertype: [],
    productiontype: [],
    producttype: [],
    processtype: [],
    pictures: [],
    preparation: "",
    orderNum: 0,
    arrivaltime: "",
    deliveryType: "",
    shippingtime: "",
    destination: "",
    calculation: "",
    advance: "",
    payment: "",
    balance: "",
    general: "",
    special: "",
    settlement: [],
    other: "",
    shipping: [],
    price: 0,
    period: "",
    productName: "",
    examineWay: [],
    thirdParty: "",
    inspectionMethod: "",
    currencyType:"",
    meansPayments:""
})
const product = ref([{
    productName: "",
    productType: "",
    documentation: "",
    pictures: "",
    // inputCounts:[],
    inputCounts: [''],
    tableList: [{
        skuColor: ""
    }]
}])

//图片逻辑判断
// Event handler triggered before the image upload starts
const beforeImageUpload = (file) => {
    // Check if the file is an image
    const isImage = file.type.startsWith('image/');

    if (!isImage) {
        // Display an error message
        ElMessage.error('只能上传JPG/PNG文件');
        // Cancel the upload
        return false;
    }

    // Check if the file size is within the limit (5MB)
    const isSizeValid = file.size <= 5 * 1024 * 1024; // 5MB in bytes

    if (!isSizeValid) {
        // Display an error message
        ElMessage.error('文件大小不能超过5MB');
        // Cancel the upload
        return false;
    }

    // Continue with the upload
    return true;
};
const handleImageUploadSuccess = (response, file) => {
    // Handle the successful image upload
    orderForm.pictures.push({
        name: response.data.name,
        url: response.data.url
    })
    .log(orderForm.pictures, 'orderForm.pictures');
};


// Event handler triggered on image upload error
const handleImageError = (error, file, fileList) => {
    ElMessage.error('图片上传失败');
};



const beforePDFUpload = (file) => {
    // Check if the file is a PDF
    const isPDF = file.type === 'application/pdf';

    if (!isPDF) {
        // Display an error message
        ElMessage.error('只能上传 PDF 文件');
        // Cancel the upload
        return false;
    }

    // Continue with the upload
    return true;
};

// Event handler triggered on successful upload
const orderContractSuccess = (response, file) => {
    // Handle the successful upload
    orderForm.preparation = response.data.url
};

// Event handler triggered when the number of uploaded files exceeds the limit
const handleExceed = (files, fileList) => {
    ElMessage.warning('只能上传一个 PDF 文件');
};

// Event handler triggered on upload error
const handleError = (error, file, fileList) => {
    ElMessage.error('文件上传失败');
};

// 点击新增尺码时，在输入框数量数组中增加一个计数
const addInput = (productIndex) => {
    product.value[productIndex].inputCounts.push('')
}

// 点击新增颜色时，向表格数据数组中添加新的对象
const addTableRow = (list) => {
    list.push({ skuColor: '' })
}
// 添加一个函数来根据索引删除尺码
const deleteSize = (sizeIndex) => {
    // 从 inputCounts 数组中删除给定索引的尺码
    product.value[sizeIndex].inputCounts.pop();
    // 此外，如果使用了相应的 Scope 数据，也要删除它
    // 处理任何其他需要删除的尺码内容
}
const deleteRow = (index, list) => {
    list.splice(index, 1)
}

const getUser = () => {
    getOrderUser().then(res => {
        if (res.data.code == 200) {
            orderForm.companyName = res.data.data[0].companyName
            orderForm.contacts = res.data.data[0].contacts
            orderForm.phonenumber = res.data.data[0].phonenumber
        }
    })
}
const calculateTotal = (row, item) => {
    let total = 0;
    item.inputCounts.forEach(count => {
        total += Number(row[count]) || 0;
    })
    return total
}


const totalOrderQuantity = computed(() => {
    return product.value[0].tableList.reduce((total, row) => {
        return total + calculateTotal(row, product.value[0]);
    }, 0);
});

const orderBtn = () => {
    // 检查是否有必填字段为空
    const emptyFields = Object.keys(orderForm).filter(
        key => orderFormRules[key] && orderFormRules[key].some(orderFormRules => orderFormRules.required) && !orderForm[key]
    );

    if (emptyFields.length > 0) {
        // 有必填字段为空，提示用户并阻止注册
        ElMessage.error('请填写所有必填字段');
        return;
    }
    // const totalQuantity = totalOrderQuantity.value;
    // if (totalQuantity !== orderForm.orderNum) {
    //     // Display an error message (you can customize this)
    //     ElMessage.error('订单总数与订单数量不匹配，请检查。');
    //     return;
    // }
    let newArr = JSON.parse(JSON.stringify(product.value));
    let headerArr = JSON.parse(JSON.stringify(inputCounts.value));
    let newArrList = [];
    newArrList = newArr[0].tableList
    let letterIntent = {
        companyName: orderForm.companyName,
        contacts: orderForm.contacts,
        examineWay: orderForm.examineWay,
        thirdParty: orderForm.thirdParty,
        inspectionMethod: orderForm.inspectionMethod,
        phonenumber: orderForm.phonenumber,
        clientType: orderForm.type.join(","),
        orderType: orderForm.ordertype.join(","),
        productType: orderForm.productiontype.join(","),
        productMold: orderForm.producttype.join(","),
        processType: orderForm.processtype.join(","),
        prepareDocument: orderForm.preparation,
        productName: orderForm.productName,
        currencyType:orderForm.currencyType,
        examineWay:orderForm.examineWay.join(","),
        thirdParty:orderForm.thirdParty,
        inspectionMethod:orderForm.inspectionMethod
    }
    let deliveryManage = {
        materialTime: orderForm.arrivaltime,
        deliveryType: orderForm.deliveryType,
        shipmentTime: orderForm.shippingtime,
        shipmentDestination: orderForm.destination,
        advancePayment: orderForm.advance,
        disbursementFunds: orderForm.payment,
        finalPayment: orderForm.balance,
        affiliatingArea: orderForm.period,
        generalTaxPoint: orderForm.general,
        dedicatedTaxPoint: orderForm.special,
        meansPayments: orderForm.settlement.join(","),
        other:orderForm.other,
        shippingMethod: orderForm.shipping.join(","),
        intendedTargetPrice: orderForm.price
    }
    let obj = {
        tableList: newArrList,
        letterIntent: null,
        deliveryManage: null,
        pictures: orderForm.pictures
    }
    obj.letterIntent = letterIntent
    obj.deliveryManage = deliveryManage
    customerOrder(obj).then(res => {
        if (res.data.code == 200) {
            ElMessage.success("下单成功")
            router.push("/index")
        } else {
            ElMessage.error("下单失败")
        }
    })
}
const inputCounts = ref([''])

</script>

<style scoped>
.placeOrder {
    background: #F8F8F8;
    margin-top: 1.15rem;
    overflow: hidden;
}

.orderBox {
    background: #FFFFFF;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin: .125rem 2.25rem;
    overflow: hidden;
}

.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: .3rem;
    cursor: pointer;
}

.infor {
    height: .6375rem;
    background: #EEEEEE;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    margin-left: .35rem;
    margin-right: .35rem;
    margin-top: .2625rem;
    line-height: .6375rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    text-align: left;
    padding-left: .25rem;
}

.formBox {
    margin-top: .3rem;
    text-align: left;
    margin-left: .425rem;
}

::v-deep .el-form-item__label {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #333333;
}

.formBox ::v-deep .el-input {
    width: 2.5rem;
    height: .475rem;
    background: #FFFFFF;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
}

.formBox ::v-deep .el-checkbox__label {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #000000;
}

.formBox ::v-deep .el-checkbox {
    margin-right: .9625rem;
}

.uploadBtn {
    width: 1.6375rem;
    height: .475rem;
    background: #002FA7;
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    border: .0125rem solid #DDDDDD;
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}

.colorStyle {
    font-size: .2rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #002FA7;
    margin-top: .15rem;
}

.submit {
    width: 4.2125rem;
    height: .8rem;
    background: #002FA7;
    /* border-radius: 0px 0px 0px 0px; */
    opacity: 1;
    font-size: .2375rem;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
}

.orderTable ::v-deep .el-input {
    width: .925rem;
    /* height: 34px; */
    background: #FFFFFF;
    border-radius: .025rem .025rem .025rem .025rem;
}

::v-deep .el-input.is-disabled .el-input__inner {
    color: #333 !important;
    -webkit-text-fill-color: #333 !important
}
::v-deep .el-radio__label {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-left: .125rem;
}

.chimaBtn {
    font-size: .175rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    color: #002FA7;
    padding: .1rem;
}
::v-deep .el-form--inline .el-form-item {
    margin-right: .4rem;
}


/* .orderTable ::v-deep .el-input__wrapper {
    width: 74px;
    height: 34px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    } */</style>
